import { useLayoutEffect, useState } from "react"

import { Flex, Space, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import { useIncognito } from "../../../../hooks/useIncognito"
import Icon from "../../../../Icon"
import AppUtils from "../../../../Utils/utils"
import ReferralActions from "../../../Referrals/reducer"

import "./ShareLink.less"

const { Text } = Typography

const ShareLink = () => {
  const dispatch = useDispatch()
  const link = useSelector((state) => state.referrals?.inviteLink)
  const { userInfo } = useSelector((state) => state.auth)
  const visibleLink = userInfo?.is_demo ? "https://app.chargeback.io/example" : link
  const [isCopied, setIsCopied] = useState(false)
  const incognito = useIncognito()

  useLayoutEffect(() => {
    dispatch(ReferralActions.getInviteLinkRequest())
  }, [])

  const copy = () => {
    AppUtils.copyToClipboard(visibleLink)
    setIsCopied(true)
  }

  return (
    <Space direction="vertical" size={8} className="share-link">
      <Text>{t("Share this unique link to invite your friends")}</Text>
      <Flex>
        <Space size={12} className="share-link__row">
          <ButtonComponent
            icon={
              isCopied ? (
                <Icon className="check-copied" type="check" />
              ) : (
                <Icon type="copy" style={{ fontSize: "16px" }} />
              )
            }
            size="large"
            onClick={copy}
            iconPosition="end"
          >
            <Private>{visibleLink}</Private>
          </ButtonComponent>
        </Space>
      </Flex>
    </Space>
  )
}

export default ShareLink
